import * as React from 'react';
import Box from '@mui/material/Box';
import Slider from '@mui/material/Slider';
import InfoIcon from '@mui/icons-material/Info';
import Tooltip from '@mui/material/Tooltip';


const marksTrialLength = [
    {value: 100,label: '100ms',},{value: 200,label: '200ms',},{value: 300,label: '300ms',},{value: 400,label: '400ms',},{value: 500,label: '500ms',}];
  
  const marksTrialAmount = [
      {value: 5,label: '5',},{value: 10,label: '10',},{value: 15,label: '15',},{value: 20,label: '20',}];
    

function valuetext(value, funky) {
  return value;
}


export default function DiscreteSliderMarks5({setTrialSliderValue, markers, compareColour, sliderTitle, marksAmount, minAmount, stepAmount, defaultVal}) {
    var marko = window["marksTrialLength"]

    const wrapperStyle = { width: 400, marginRight: 50, marginLeft: 50, marginBottom: 0, marginTop: 0  };

    const doNothing = () => {
    };
    const handleChange = (event, newValue) => {
    
        setTrialSliderValue(newValue);
      };
    
  return (
    <div style={wrapperStyle}>
      <h3 className="widgetLgTitle">{sliderTitle} <Tooltip title="The number of subjects data to run the experiment on.">
        <InfoIcon color='primary' > </InfoIcon>
</Tooltip></h3>

    <Box sx={{ width: 500 }}>
      <Slider
        aria-label="Custom marks"
        defaultValue={5}
        getAriaValueText={valuetext}
        min={5}
        step={null}
        max={20}
        marks={marksTrialAmount}
        onChange={handleChange}
        color={compareColour}
      />
    </Box>
    
    </div>
  );
}
